<template>
  <el-tabs v-model="tabsName" @tab-click="gotoOtherPage">
    <el-tab-pane v-for="(item,index) in list" :key="index" :label="item.name" :name="item.name">
    </el-tab-pane>
  </el-tabs>
</template>

<script type="text/ecmascript-6">
import { tool } from "../common/js/tool.js";
export default {
  data() {
    return {
      tabsName: "",
      list: [
        { name: "历史轨迹回放", url: "/search/tracked" },
        { name: "历史轨迹列表", url: "/search/tracked-list" },
      ]
    };
  },

  props: ["name"],

  computed: {},

  created() {},

  updated() {
    this.tabsName = this.name;
  },

  methods: {
    gotoOtherPage() {
      // let hash = window.location.hash.replace("#", "");
      let hash = this.$route.query.u;
      // console.log(hash);
      // console.log(this.$route.query.u);
      for (let i = 0; i < this.list.length; i++) {
        if (this.tabsName == this.list[i].name) {
          console.log(this.list[i].url);
          this.$router.push({
            path: this.list[i].url,
            query: { u: "/search/tracked" }
          });
          break;
        }
      }
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
@import "../common/less/variable.less";
</style>
